// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_859a21e","status":"_ca17d87"};